module.exports = __webpack_public_path__ + "img/gw3.8ba6010d.png";